import { api_without_cancellation } from "@/api/api";

const unwrapData = (response) => response?.data?.data ?? response?.data;

const normalizeFaxError = (error, fallback) => {
  const responseData = error?.response?.data;
  const message =
    responseData?.error ||
    responseData?.detail ||
    responseData?.message ||
    error?.message ||
    fallback;
  const normalizedError = new Error(message);
  normalizedError.response = error?.response;
  return normalizedError;
};

const request = async (action, fallback) => {
  try {
    return unwrapData(await action());
  } catch (error) {
    throw normalizeFaxError(error, fallback);
  }
};

export const startFax = (payload) =>
  request(
    () => api_without_cancellation.post("/api/fax/start/", payload),
    "Unable to create the fax cover sheet."
  );

export const getFaxRecord = (recordId) =>
  request(
    () => api_without_cancellation.get(`/api/fax/record/${recordId}/`),
    "Unable to refresh the fax."
  );

export const finalizeFax = (recordId, docIds) =>
  request(
    () =>
      api_without_cancellation.post(`/api/fax/record/${recordId}/finalize/`, {
        doc_ids: docIds,
      }),
    "Unable to finalize the fax."
  );

export const sendFax = (recordId) =>
  request(
    () => api_without_cancellation.post(`/api/fax/record/${recordId}/send/`),
    "Unable to send the fax."
  );

export const getFaxDocuments = async ({ caseId, pageId = "all" }) => {
  try {
    const response = await api_without_cancellation.get("/api/doc-page/doc-page-popup-api/", {
      params: {
        case_id: caseId,
        page_id: pageId,
      },
    });
    return response?.data?.data || [];
  } catch (error) {
    throw normalizeFaxError(error, "Unable to load the case documents.");
  }
};
